export default "__VITE_ASSET__d7f74bcb__"